import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationType, Modules, NotificationHeader, NotificationDetails, RoutingPath } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { GetGatewayDetails, GetSubmitAccountDetails, PreviewHtmlReportFile, SubmitReport } from '@app/core/Store/report/submitCompanyHouse';
import { AddClosePopupComponent, ConfirmationBoxComponent, MessageBoxComponent } from '@app/modules/common';
import { Store } from '@ngxs/store';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { GatewayDetailComponent } from './gateway-detail/gateway-detail.component';
import { GetSavedAnnualReportResponse } from '@app/core/Store';
import { ValidateReportComponent } from './validate-report/validate-report.component';

@Component({
  selector: 'app-submit-list',
  templateUrl: './submit-list.component.html',
  styleUrls: ['./submit-list.component.scss']
})
export class SubmitListComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild( GatewayDetailComponent, { static: true }) gatewayDetailsView;
  _Activatedroute: ActivatedRoute;
  submitRouting: Subscription;
  recordId: any;
  submitId: any = this.commonService.defaultGuidValue;
  gatewayDetails: any;
  submitAccountDetails: any;
  fileDetails: any;
  accountingPeriodId:any;
  @ViewChild( ValidateReportComponent, { static: true }) child;
  constructor(private injector: Injector, private store: Store, private cookieService: CookieService, public dialog: MatDialog, private commonService: CommonService, public router: Router) {
    this._Activatedroute = injector.get<ActivatedRoute>(ActivatedRoute); 
  }

  ngOnInit(): void {
    this.submitRouting = this._Activatedroute.paramMap.subscribe(
      (params) => {
        if (params.keys.length > 0) {
          this.recordId = params.get('id');
          this.accountingPeriodId = params.get('periodId');
          if(params.get('submitId')){
            this.submitId = params.get('submitId');
          }
        }
      }
    );
    this.previewHtmlReportFile();
  }

  goNext() {
    if (this.stepper.selectedIndex < this.stepper.steps.length - 1) {
      if(this.stepper.selectedIndex == 2 && this.gatewayDetailsView.formDetails.invalid){

      } else {
       this.stepper.next();  // Go to the next step
      }
    } 
    if(this.stepper.selectedIndex == 1){
      this.getGatewayDetails();
    }else if(this.stepper.selectedIndex === this.stepper.steps.length - 2){
      this.getSubmitAccountDetails();
    }
  }

  goPrevious() {
    if (this.stepper.selectedIndex > 0) {
      this.stepper.previous();  // Go to the previous step
    }
  }

  previewHtmlReportFile(): void{
    this.store.dispatch(new GetSavedAnnualReportResponse(this.accountingPeriodId,this.recordId)).pipe().subscribe(
      (response: any) => {
        this.fileDetails = response?.annualReport?.getContent;
      }
    );
  }

  getGatewayDetails(): void{
    this.store.dispatch(new GetGatewayDetails(this.submitId)).pipe().subscribe(
      (response: any) => {
        this.gatewayDetails = response?.SubmitCompanyHouse?.gatewayDetails;
      }
    );
    
  }

  getSubmitAccountDetails(): void{
    this.store.dispatch(new GetSubmitAccountDetails(this.accountingPeriodId)).pipe().subscribe(
      (response: any) => {
        this.submitAccountDetails = response?.SubmitCompanyHouse?.submitAccountDetails;
      }
    );
  }

  saveData(): void{
    const companyid = this.cookieService.get('companyid');
    const payload = {
      id: this.submitId,
      submitDate: moment().format('YYYY-MM-DDT00:00:00'),
      isSubmitted: false,
      isTest: true,
      companyId: companyid,
      status: "Unknown",
      submissionNumber: "",
      reportId: this.recordId,
      presenterId: this.gatewayDetailsView?.formDetails?.value?.presenterId,
      authenticationCode: this.gatewayDetailsView?.formDetails?.value?.authenticationCode,
      email: this.gatewayDetailsView?.formDetails?.value?.email,
      companyAuthorisationId: this.gatewayDetailsView?.formDetails?.value?.companyAuthorisationId,
      fromDate: this.submitAccountDetails.reportStartdate,
      toDate: this.submitAccountDetails.reportEndDate,
      signDate: this.submitAccountDetails.directorSigndate,
      companyName: this.submitAccountDetails.companyName,
      companyNumber: this.submitAccountDetails.companyNo,
      accountingPeriodId: this.accountingPeriodId
    }

    this.store.dispatch(new SubmitReport(payload)).pipe().subscribe(
      (response: any) => {
        this.redirectToSubmit(response.SubmitCompanyHouse?.message, response.SubmitCompanyHouse?.isSuccess);
      }
    );
  }

  redirectToSubmit(message: any, isSuccess: any): void{
    this.dialog
      .open(MessageBoxComponent, {
        data: {
          ConfirmationType: isSuccess ? 'success' : 'error',
          headerText: NotificationHeader.redirect,
          detailText: message,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.router.navigate([RoutingPath.submissions]);
        }
      });
  }

  onSaveClick(): void {
    this.dialog
      .open(ConfirmationBoxComponent, {
        data: {
          type: ConfirmationType.Save,
          moduleId: Modules.submitCompaniesHouse,
          totalNumberOfRecordSelected: 1,
          headerText: NotificationHeader.confirmation,
          detailText: NotificationDetails.Submit,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.saveData();
        }
      });
  }
  onCloseClick(): void {
    this.dialog.open(AddClosePopupComponent, {});
  }
}
